'use strict';

import './ClickToCopy.less';

import React from 'react';
import PropTypes from 'prop-types';
import Clipboard from 'clipboard';
import RoundButton from './RoundButton';

export default class ClickToCopy extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			copySuccess: null,
			copyError: null
		};
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
			this.clipboard = new Clipboard(this.roundButton.dom, {
				text: () => {
					return this.props.copyText;
				}
			});

			this.clipboard.on('success', () => {
				clearTimeout(this.tooltipTimeout);

				this.tooltipTimeout = setTimeout(
					() =>
						this.setState({
							copySuccess: null
						}),
					2000
				);

				this.setState({
					copySuccess: 'Copied to clipboard'
				});
			});

			this.clipboard.on('error', () => {
				CK.logger.warn('Error using ClickToCopy');

				this.setState({
					copyError: true
				});
			});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.tooltipTimeout);
		this.clipboard && this.clipboard.destroy();
	}

	render() {
		const className = 'ClickToCopy';

		if (this.state.copyError) {
			return (
				<div className={className}>
					<p className="error">There was an error while copying, please copy the text manually:</p>
					<p>${this.props.copyText}</p>
				</div>
			);
		} else {
			return (
				<div className={className}>
					<RoundButton
						size="tiny"
						colour="yellow"
						ref={e => (this.roundButton = e)}
						{...this.props}
					/>
					{this.state.copySuccess && <div className="status">{this.state.copySuccess}</div>}
				</div>
			);
		}
	}
}

ClickToCopy.propTypes = {
	copyText: PropTypes.string.isRequired
};
